const initialState = {
    refreshUserTable:'',
    searchUserValue:'',
};
export const actionTypes = {
    REFRESH_USER_TABLE: "REFRESH_USER_TABLE",
    SEARCH_USER_TABLE:"SEARCH_USER_TABLE",
};

export const actions = {
    refresh_user_table: function (data) {
        return {
            type: actionTypes.REFRESH_USER_TABLE,
            data
        }
    },
    search_user_table: function (data) {
        return {
            type: actionTypes.SEARCH_USER_TABLE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.REFRESH_USER_TABLE:{
            return {...state,refreshUserTable:action.data}
        }
        case actionTypes.SEARCH_USER_TABLE:{
            return {...state,searchUserValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/userManagerReducer.js